const _temp0 = require("./config/25madison.json");
const _temp1 = require("./config/alon.json");
const _temp2 = require("./config/demo.json");
const _temp3 = require("./config/demo_3.json");
const _temp4 = require("./config/dev.json");
const _temp5 = require("./config/harvest.json");
const _temp6 = require("./config/odyssey.json");
const _temp7 = require("./config/test-env.json");
const _temp8 = require("./config/testing.json");
module.exports = {
  "25madison": _temp0,
  "alon": _temp1,
  "demo": _temp2,
  "demo_3": _temp3,
  "dev": _temp4,
  "harvest": _temp5,
  "odyssey": _temp6,
  "test-env": _temp7,
  "testing": _temp8
}